import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../Contexts/AuthContext/AuthProvider";
import axios from "axios";
import CustomPaginationMobile from "../../../../CustomPagination/CustomPaginationMobile";
import SingleItem from "./SingleItem";
import NFTHistoryDetails from "./NFTHistoryDetails/NFTHistoryDetails";
import Skeleton from "react-loading-skeleton";
import NFTReminingHistory from "./NFTHistoryDetails/NFTReminingHistory";

const MobileNFTBuyHistory = () => {
  const { authUser } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginateData, setPaginateData] = useState([]);

  useEffect(() => {
    if (authUser?._id) {
      fetch(
        `https://api.wlfmobile.com/api/user/nft/buy/history/view/${authUser?._id}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setData(data.data);
          setPaginateData(data);
          setLoading(false);
        });
    }
  }, [authUser?._id]);

  const handlePage = (event) => {
    try {
      const pageNumber = event?.selected + 1;
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      axios
        .get(
          `https://api.wlfmobile.com/api/user/nft/buy/history/all/view/${authUser?._id}?page=${pageNumber}`,
          config
        )
        .then((response) => {
          setData(response?.data?.data);
          setPaginateData(response?.data);
        })
        .catch((error) => {});
    } catch (error) {
      console.log(error);
    }
  };

  const [singleDataId, setSingleDataId] = useState(null);
  const [Modal, setModalhow] = useState(false);

  const HandleModalShow = (id) => {
    setSingleDataId(id);
    setModalhow(true);
  };

  const [CoinModal, setCoinModal] = useState(false);

  if (loading) {
    return (
      <section className="mobile-version">
        <div className="Mobile-version-slider">
          <Skeleton count={35} height={35} />
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="mobile-history-page-area">
        <div className="container">
          <div className="d-flex justify-content-center">
            <button
              className="nav__link js-tabs-link active"
              style={{ color: "lime" }}
              onClick={() => setCoinModal(true)}
            >
              Total NFT&nbsp;:&nbsp;
              {paginateData?.totalCoin ? paginateData?.totalCoin : 0.0}
            </button>
          </div>
          <div className="mobile-history-item-area">
            <section className="mobile-history-item-list">
              {data?.length !== 0 ? (
                data.map((data, index) => {
                  if (data) {
                    return (
                      <SingleItem
                        data={data}
                        index={index}
                        key={data?._id}
                        HandleModalShow={HandleModalShow}
                        paginateData={paginateData}
                      ></SingleItem>
                    );
                  }
                })
              ) : (
                <div className="text-center pt-5">
                  <p className="text-write">No records available</p>
                </div>
              )}

              {/* paginateLinks */}
              <CustomPaginationMobile
                data={paginateData}
                handlePage={handlePage}
              ></CustomPaginationMobile>
              {/* paginateLinks */}
            </section>
          </div>
        </div>
      </section>

      {(() => {
        if (Modal) {
          return (
            <NFTHistoryDetails
              singleDataId={singleDataId}
              setShow={setModalhow}
              show={Modal}
            ></NFTHistoryDetails>
          );
        }
      })()}

      {(() => {
        if (CoinModal) {
          return (
            <NFTReminingHistory
              setShow={setCoinModal}
              show={CoinModal}
            ></NFTReminingHistory>
          );
        }
      })()}
    </>
  );
};

export default MobileNFTBuyHistory;
